
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import CurrencyConverter from '../../CurrencyConverter';
//Components
import WishListIcon from '../../../components/WishListIcon';
import ListCoverPhoto from '../../ListCoverPhoto/ListCoverPhoto';

// Locale
import messages from '../../../locale/jsonMessages';
import { formatURL } from '../../../helpers/formatURL';
import { getDynamicName, getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';

import steeringIcon from '/public/SiteIcons/steeringIcon.svg';
import startIcon from '/public/SiteIcons/star.svg'
import arrowIcon from '/public/SiteIcons/rentNowArrow.svg';
import { InstantBookSvgIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../../components/commonStyle.css';
import s from '../../Home/HomeSlider/HomeSlider.css';
function ListingItem(props) {

  const { data, similiarListPadding, isEditWishList, locale, dynamicLanguageData, dynamicTitle } = props;
  const { formatMessage } = useIntl();

  return (
    <>
      {
        data?.length > 0 && data.map((item, index) => {
          let carType, transmission, isListOwner, transmissionLabel, starRatingValue = 0, dynamicListTitle;
          carType = getDynamicName({ value: item?.settingsData[0]?.listsettings, locale, data: dynamicLanguageData });
          carType = carType?.itemName;
          dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id: item?.id });
          transmission = item.transmission;
          isListOwner = item.isListOwner
          transmission == '1' ? transmissionLabel = formatMessage(messages.automatic) : transmissionLabel = formatMessage(messages.manual);
          if (item?.reviewsCount > 0 && item?.reviewsStarRating > 0) {
            starRatingValue = Math.round(item?.reviewsStarRating / item?.reviewsCount)
          }
          if (item?.listPhotos?.length > 0) {
            return (
              <div className={cx(s.background, s.positionRelative, similiarListPadding)}>
                {
                  !isListOwner && <WishListIcon listId={item.id} key={item.id} isChecked={item.wishListStatus} isEditWishList={isEditWishList} />
                }
                <a href={"/cars/" + formatURL(item.title) + '-' + item.id} target={'_blank'} className={cs.textDecorationNone}>
                  <div className={s.boxShadow}>
                    <ListCoverPhoto
                      className={s.HRCar}
                      listPhotos={item?.listPhotos}
                      coverPhoto={item?.coverPhoto}
                      photoType={"x_medium"}
                      bgImage
                    />
                    <div className={s.PerDayWrap}>

                    </div>
                    <div className={s.sliderbackground}>
                      <div className={cx(cs.listingCardCarTypeAndTransmissionLabelFlexContainer, cs.spaceBottom1)}>
                        <div className={cs.textFlow}>
                          <img src={steeringIcon} className={cs.carTypeIcon} />{' '}
                          <span>{carType}</span>
                        </div>
                        <div className={cx(cs.textFlow, cs.transmissionLabelText, 'transmissionLabelTextRtl')}>{transmissionLabel}</div>
                      </div>
                      <div className={cx(s.PerDay)}>
                        {
                          item?.bookingType === "instant" && <span><InstantBookSvgIcon className={s.instantIcon} /></span>
                        }
                        <CurrencyConverter
                          amount={item?.listingData?.basePrice}
                          from={item?.listingData?.currency}
                        />
                        <span className={cx(s.perNightCss, 'PerDayRTL')}>{' '}{formatMessage(messages.perNight)}</span>
                      </div>
                      <h3 className={s.titleCss}>{dynamicListTitle || item.title}</h3>
                      <div className={s.HRRight}>
                        {starRatingValue > 0 && <div className={cx(s.reviewCss, 'reviewCssSliderRTL')}>
                          <img src={startIcon} className={cx(s.reviewCssImg, 'reviewCssImgRTL')} /><span>{starRatingValue}</span>
                        </div>}
                        <a className={cx(s.btn, cs.textDecorationNone)} href={"/cars/" + formatURL(item.title) + '-' + item.id} target={'_blank'}>
                          <span className={cs.vtrMiddle}><FormattedMessage {...messages.rentNowText} /></span>
                          <img src={arrowIcon} className={cx(s.arrowIconCss, 'sliderArrowRTL')} />
                        </a>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            )
          }
        })
      }
    </>
  );
}

export default (withStyles(cs, s)(ListingItem));